import React from 'react'
import Layout from '../../Components/Layout/Layout'
import LoginComponent from '../../Components/Auth/LoginComponent'

const Login = () => {
  return (
    <>
      <Layout>
        <LoginComponent />
      </Layout>
    </>
  )
}

export default Login


